module.exports = __webpack_public_path__ + "static/media/revenue-cat-logo.31f0b171.jpeg";